module.exports = __webpack_public_path__ + "static/media/locallodging.d7baaae7.png";